/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineFullscreen } from "react-icons/ai";
import { MdOutlineClose } from "react-icons/md";
import { useFontStyle } from "~/hook/useFontStyle";
import useStopCurrentRunningVideoAudio from "~/hook/useStopCurrentRunningVideoAudio";
import { getYoutubeVideoThumbnail } from "~/lib/helperFuncation/youtubeThumbnails";
import {
  onPauseVideo,
  onPlayVideo,
  setCurrentVideo,
  setCurrentVideoPosition,
  setYoutubeVideoIsPlay,
  videoDataType,
} from "~/lib/store/slice/youtubePlayerSlice";
import { useAppDispatch } from "~/lib/store/store";
import { cn } from "~/lib/utils";
import { VIDEO_PLAYER } from "~/utils/constant";
import { convertSecondsToHMS } from "~/utils/helper-funcations";
import YoutubeVideoPlayer from "../shared-components/YoutubeVideoPlayer";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import VideoPlayingBar from "../video-grid/VideoPlayingBar";

interface DesktopVideoPopupProps {
  currentVideo: { videoId: string; from: string } | null;
  currentPlayVideo: videoDataType;
  playListQueueData: videoDataType[];
  isVideoPlay: boolean;
  onClose: () => void;
  onFullScreen: () => void;
  onNextVideo: () => void;
}

function DesktopVideoPopup({
  currentVideo,
  currentPlayVideo,
  playListQueueData,
  isVideoPlay,
  onClose,
  onFullScreen,
  onNextVideo,
}: DesktopVideoPopupProps) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { medium, mediumInter, normalInter } = useFontStyle();
  const { playCurrentVideo } = useStopCurrentRunningVideoAudio();

  return (
    <div className="fixed left-2 sm:left-auto right-2 bottom-0 md:bottom-5 sm:right-5 overflow-hidden shadow-[0px_4px_46px_0px_rgba(114,52,25,0.20)] z-50 rounded-lg animate-slide-up">
      <div className="group aspect-video h-[200px] 2xl:h-[250px] rounded-lg ">
        <YoutubeVideoPlayer
          key={currentVideo?.videoId}
          handlePlayVideo={() => playCurrentVideo(currentVideo?.videoId || null)}
          videoId={currentVideo ? currentVideo.videoId : "PJab2ScnQQs"}
          handleNextVideo={onNextVideo}
        />
        {/* Hover overlay for icons */}
        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          <AiOutlineFullscreen
            className="absolute top-3 left-3 text-white size-6 cursor-pointer pointer-events-auto"
            onMouseDown={(e) => {
              e.stopPropagation();
              onFullScreen();
            }}
            title="back to tab"
          />
          <MdOutlineClose
            className="absolute top-3 right-3 text-white size-6 cursor-pointer pointer-events-auto"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
              dispatch(onPauseVideo());
              dispatch(setYoutubeVideoIsPlay(false));
              dispatch(setCurrentVideo(null));
              sessionStorage.removeItem(VIDEO_PLAYER.CURRENT_VIDEO);
              sessionStorage.removeItem(VIDEO_PLAYER.VIDEO_QUEUE);
              sessionStorage.removeItem(VIDEO_PLAYER.IS_VIDEO_PLAY);
              sessionStorage.removeItem(VIDEO_PLAYER.CURRENT_VIDEO_POSITION);
              sessionStorage.removeItem(VIDEO_PLAYER.VIDEO_QUEUE);
              sessionStorage.removeItem(VIDEO_PLAYER.YOUTUBE_VIDEO_IS_PLAY);
            }}
            title="close player"
          />
        </div>
      </div>

      {currentPlayVideo?.name && (
        <Accordion
          type="single"
          collapsible={true}
          className="w-full md:w-[356px] 2xl:w-[445px] shadow-[0px_4px_46px_0px_rgba(114,52,25,0.20)]  cursor-pointer border-l border-r border-b border-borderPrimary "
        >
          <AccordionItem value="item-1" className="w-full bg-secondaryBackground">
            <AccordionTrigger iconVisible={playListQueueData?.length > 0 ? true : false} className="w-full flex  p-1.5 px-2">
              <p className={cn("text-14 md:text-16 py-1 text-textColorPrimary leading-6 line-clamp-1", medium)}>{currentPlayVideo.name}</p>
            </AccordionTrigger>
            {playListQueueData?.length ? (
              <AccordionContent
                className="border-t-[1px] border-borderPrimary p-1 w-full max-h-[250px] 2xl:max-h-[300px] overflow-y-auto"
                style={{ touchAction: "none" }}
              >
                <div className="flex flex-col gap-1.5 ">
                  {playListQueueData?.map((item: videoDataType, index: number) => (
                    <div
                      key={index}
                      className={cn(
                        "flex gap-2 h-16 px-1 mt-1 hover:bg-primaryColor/10 rounded-lg transition-all duration-200 ease-in-out",
                        item.videoId === currentPlayVideo.videoId ? "bg-primaryColor/10" : "",
                      )}
                      onClick={() => {
                        dispatch(setCurrentVideo(item));
                        dispatch(onPlayVideo(item.videoId));
                        dispatch(setCurrentVideoPosition(0));
                        dispatch(setYoutubeVideoIsPlay(true));
                      }}
                    >
                      <div className="relative w-26 2xl:w-28 aspect-video flex-shrink-0 rounded-lg overflow-hidden">
                        <img
                          src={getYoutubeVideoThumbnail(item.videoId, "medium") || ""}
                          alt={item?.name || ""}
                          className="w-full h-full rounded-lg select-none"
                        />
                        {currentPlayVideo.videoId === item.videoId && isVideoPlay && (
                          <div className="absolute bottom-1 right-1 flex items-center justify-center bg-slate-800/70 p-1 px-2  rounded-lg">
                            <VideoPlayingBar />
                          </div>
                        )}
                      </div>

                      <div className="flex flex-col  w-full">
                        <div className="flex flex-col gap-x-1 justify-start items-start ">
                          <p
                            className={cn("text-14 title-global-video-player-size text-textColorPrimary line-clamp-2 capitalize ", mediumInter)}
                            title={item?.name ?? undefined}
                          >
                            {item.name}
                          </p>

                          {item?.duration && (
                            <div className="flex flex-wrap justify-start items-center gap-2">
                              <span className={cn("text-12 duration-text-size 2xl:text-14 text-textColor", normalInter)}>
                                {convertSecondsToHMS(item?.duration || 0)}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </AccordionContent>
            ) : null}
          </AccordionItem>
        </Accordion>
      )}
    </div>
  );
}

export default memo(DesktopVideoPopup);
